export function Progress({ done, total }: { done: number; total: number }) {
  const w = total > 0 ? Math.round((100 * done) / total) : 0;
  return (
    <>
      <span className="progress">
        <span style={{ width: `${w}%` }} />
      </span>
      {done}/{total}
    </>
  );
}
